
import { TrustAPI } from "@/shared/modules/trust-api";
import { FirmSearchRequest, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import debounce from "lodash/debounce";
import { Inject, Options, Vue, Watch } from "vue-property-decorator";
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { RouteN } from "@/trust-admin-app/constants/router-name";
import { AppInsights } from "@/trust-admin-app/appInsights";
import store from "@/trust-admin-app/store";
import { EventEmitter } from "events";
@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
  },
})
export default class TrustDataPractices extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }


  private search = '';
  private isSearching = false;
  private srchDebounced: any = null;

  private loadingContent = false;
  private errorLoadingContent = false;


  private tableHeadings = [
    { text: 'Practice (Trading name)', value: 'name', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Practice - Branch ID', value: 'email', sortMehod: 'asc', sortable: false, activeSort: false },
    { text: 'Branch address', value: 'role', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Practice status', value: 'supervisor', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Trust account status', value: 'chargeAmount', sortMethod: 'asc', sortable: false, activeSort: false }
  ];

  private practices: PracticeView[] = [];


  @Watch('search')
  private onKeywordChange(): void {
    setTimeout(this.srchDebounced.cancel, 0);
    setTimeout(this.srchDebounced, 0);
  }

  // created(): void {
  //   this.searchPractice();
  // }

  mounted(): void {
    this.srchDebounced = debounce(() => {
      this.searchPractice();
    }, 1000);
  }

  private async searchPractice(): Promise<void> {
    if (this.search.length > 2) {
      const _body: FirmSearchRequest = {
        keyword: this.search,
        // take: 100,
      }
      try {
        this.isSearching = true;
        this.loadingContent = true;
        const resp: any = await this.apiService.PracticeApi?.apiV2PracticeSearchPracticePost(_body);
        this.practices = resp.data.data as PracticeView[];
      } catch (err: any) {
        this.errorLoadingContent = true;
        this.ai.trackException('Error getting Practices data: ' + JSON.stringify(err));
        this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Practices data: ' + (err.response ? err.response.status.toString() : ''));
      } finally {
        this.isSearching = false;
        this.loadingContent = false;
      }
    }

  }

  get RouteN(): typeof RouteN {
    return RouteN;
  }

}

